import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import MUIListItem from 'material-ui/List/ListItem'
import classNames from 'classnames'

const styles = theme => ({
  Item: {},
  LoneWolf: {
    borderRadius: 5,
  },
  First: {
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    borderBottom: 'solid 1px ' + theme.palette.border,
  },
  InBetween: {
    borderBottom: 'solid 1px ' + theme.palette.border,
  },
  Last: {
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
  },
})

const PanelItem = ({classes, children, button, position, ...props}) => (
  <MUIListItem
    className={classNames(
      classes.Item,
      classes[position],
    )}
    button={button}
    {...props}
  >
    {children}
  </MUIListItem>
)

PanelItem.propTypes = {
  children: PropTypes.node.isRequired,
  position: PropTypes.oneOf(['LoneWolf', 'First', 'InBetween', 'Last']),
  onClick: PropTypes.func,
}

PanelItem.defaultProps = {
  button: false,
  position: 'InBetween',
  onClick: () => {},
}

export default withStyles(styles, {withTheme: true})(PanelItem)



// WEBPACK FOOTER //
// ./src/components/panelItem.jsx